/**
 * API URL prefix for the admin treasury module.
 * Note: axios.defaults.baseURL already includes the "/api" segment,
 * so we only prepend the admin scope here.
 */
export const TREASURY_API_PREFIX = "/admin/treasury";

/**
 * Endpoint paths exposed by the admin treasury module.
 */
export const TREASURY_ENDPOINTS = {
    channels: `${TREASURY_API_PREFIX}/channels`,
};

/**
 * Human labels for the two settlement rails. They cannot fund each other:
 * Orange Money only ever holds MGA, Stripe holds everything else.
 */
export const CHANNEL_LABELS = {
    orange_money: "Orange Money",
    stripe: "Stripe",
};

/**
 * Short explanation of each rail, shown under its heading.
 */
export const CHANNEL_HINTS = {
    orange_money:
        "Compte marchand Orange — encaisse et reverse uniquement en MGA. Stripe refuse les virements bancaires en ariary.",
    stripe: "Solde Stripe — encaisse et reverse toutes les autres devises.",
};
